import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { Typography, Box, Grid, AppBar, Tabs, Tab } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import Header from 'on_web/components/shared/Menu/Header/Header';
import ReportsBottomNavigation from 'on_web/components/shared/ReportsBottomNavigation/ReportsBottomNavigation';
import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';
import TraitGroupsMenu from 'on_web/components/shared/TraitGroupsMenu/TraitGroupsMenu';
import ConditionSummaryList from 'on_web/components/shared/ConditionSummaryList/ConditionSummaryList';
import ReportsOpenTextSection from 'on_web/components/shared/ReportsOpenTextSection/ReportsOpenTextSection';
import ReportsSectionTitleWithBackground from 'on_web/components/shared/ReportsSectionTitleWithBackground/ReportsSectionTitleWithBackground';
import RiskGroupAssessmentCard from 'on_web/components/shared/RiskGroupAssessmentCard/RiskGroupAssessmentCard';
import CustomAccordionList from 'on_web/components/shared/CustomAccordionList/CustomAccordionList';
import DesktopMenu from 'on_web/components/shared/Menu/DesktopMenu/DesktopMenu';
import RiskFactorExplanation from 'on_web/components/shared/RiskFactorExplanation/RiskFactorExplanation';

import { traitsHeaderBackground } from 'on_web/assets/imageList';

import { useTranslation } from 'react-i18next';

import { ROUTE_ASSESSMENT_HEALTH_RISKS_DETAILS } from 'routes';
import {
  getComorbiditiesMenuItems,
  getComorbiditiesMenuItemIndex,
  getComorbidityGroupCodeByMenuIndex,
} from 'on_web/helpers/menuItems';
import useUsersApi from '../hooks/useUsersApi';

import { reportsBottomNavigationOptions } from 'on_web/helpers/redirectHelper';

import {
  riskExistComorbidity,
  noRiskComorbidity,
} from 'on_web/assets/imageList';
import { BRIGHT_LIGHT_BLUE } from 'colours';

import useCheckScreenSize from '../hooks/useCheckScreenSize';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';
import {
  getHealthRisks,
  healthRiskGroups,
  getHealthRiskScore,
  parseHealthRisks,
  parseLikelihood,
} from 'on_web/helpers/risksHelper';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

export default function ReportsComorbidityGroup(props) {
  const [isDesktop] = useCheckScreenSize();

  const [
    currentComorbidityGroupCodeIx,
    setCurrentComorbidityGroupCodeIx,
  ] = useState(
    !props.location.state || props.location.state.group == null
      ? 2
      : getComorbiditiesMenuItemIndex(props.location.state.group)
  );
  const checkGroup = () => {
    if (
      isDesktop &&
      props !== undefined &&
      props.location.state !== undefined &&
      props.location.state.group !== undefined
    ) {
      let comorbidityCodeIx = getComorbiditiesMenuItemIndex(
        props.location.state.group
      );
      if (comorbidityCodeIx !== currentComorbidityGroupCodeIx) {
        setCurrentComorbidityGroupCodeIx(comorbidityCodeIx);
      }
    }
  };
  checkGroup();

  const { t } = useTranslation();

  const [{ getSpareAssessments }] = useUsersApi();
  const [responseHealthBasedRisks, setResponseHealthBasedRisks] = useState(
    null
  );
  const [healthBasedRisksObj, setHealthBasedRisksObj] = useState(null);
  const [likelihoodObj, setLikelihoodObj] = useState(null);
  const [responseLikelihood, setResponseLikelihood] = useState(null);

  useEffect(() => {
    if (
      props.location.state &&
      props.location.state.healthBasedRisks &&
      props.location.state.infectionLikelihood
    ) {
      setResponseHealthBasedRisks(props.location.state.healthBasedRisks);
      setHealthBasedRisksObj(
        parseHealthRisks(props.location.state.healthBasedRisks)
      );
      setResponseLikelihood(props.location.state.infectionLikelihood);
      setLikelihoodObj(
        parseLikelihood(props.location.state.infectionLikelihood, t)
      );
    } else {
      getSpareAssessments().then(resp => {
        setResponseHealthBasedRisks(resp.health_based_severity);
        setHealthBasedRisksObj(parseHealthRisks(resp.health_based_severity));
        setResponseLikelihood(resp.past_infection_likelihood);
        setLikelihoodObj(parseLikelihood(resp.past_infection_likelihood, t));
      });
    }
  }, [getSpareAssessments]);

  const getCurrentGroupCode = comorbidityGroupCodeIx => {
    return getComorbiditiesMenuItems()[comorbidityGroupCodeIx].code;
  };

  const convertToConditionSummaries = comorbidityGroupCodeIx => {
    const currentComorbidityGroupCode = getCurrentGroupCode(
      comorbidityGroupCodeIx
    );
    const group = responseHealthBasedRisks.groups.find(
      g => g.code === currentComorbidityGroupCode
    );

    const summaries = [];
    if (group) {
      for (const comorbidityCodeIx in group.risks) {
        const risk = responseHealthBasedRisks.risks.find(
          r => r.risk.code === group.risks[comorbidityCodeIx]
        );
        summaries.push(risk);
      }
    }

    return summaries;
  };

  const onIconClicked = ix => {
    trackEvent('Reporting', `Comorbidity group click ${ix}`);
    setCurrentComorbidityGroupCodeIx(ix);
  };

  /**
   * Gets array with all comorbidities that are risky in the current group.
   */
  const getRiskyComorbidites = () => {
    return convertToConditionSummaries(currentComorbidityGroupCodeIx).filter(
      item => item.level > 0
    );
  };

  /**
   * Gets array with all comorbidities that are NOT risky in the current group.
   */
  const getNotRiskyComorbidities = () => {
    return convertToConditionSummaries(currentComorbidityGroupCodeIx).filter(
      item => item.level === 0
    );
  };

  const RenderMobileVersion = () => {
    return (
      <>
        {convertToConditionSummaries(currentComorbidityGroupCodeIx).length ===
        1 ? (
          <>
            <Redirect
              to={{
                pathname: ROUTE_ASSESSMENT_HEALTH_RISKS_DETAILS,
                state: {
                  comorbidityGroupCode: getComorbiditiesMenuItems()[
                    currentComorbidityGroupCodeIx
                  ].code,
                  comorbidityCode: convertToConditionSummaries(
                    currentComorbidityGroupCodeIx
                  )[0].risk.code,
                  stateToTransferOnNavigation: getStateToTransfer(),
                  menuTitle: `${
                    responseHealthBasedRisks.groups.find(
                      g =>
                        g.code ===
                        getComorbiditiesMenuItems()[
                          currentComorbidityGroupCodeIx
                        ].code
                    ).name
                  } Overview`,
                },
              }}
            />
            ;
          </>
        ) : (
          <>
            {getRiskyComorbidites().length > 0 && (
              <>
                <ReportsSectionTitleWithBackground
                  backgroundImage={traitsHeaderBackground}
                  title={`${
                    responseHealthBasedRisks.groups.find(
                      g =>
                        g.code ===
                        getComorbiditiesMenuItems()[
                          currentComorbidityGroupCodeIx
                        ].code
                    ).name
                  } ${t(
                    'reporting.common.comorbiditiesCategories.conditionsExisting'
                  )}`}
                />
                <div
                  style={{
                    marginBottom: '60px',
                  }}
                >
                  <ConditionSummaryList
                    conditionSummaries={getRiskyComorbidites()}
                    category={
                      responseHealthBasedRisks.groups.find(
                        g =>
                          g.code ===
                          getComorbiditiesMenuItems()[
                            currentComorbidityGroupCodeIx
                          ].code
                      ).name
                    }
                    onClick={comorbidityCode => {
                      trackEvent(
                        'Reporting',
                        `Risky comorbidity click ${comorbidityCode}`
                      );
                      props.history.push({
                        pathname: ROUTE_ASSESSMENT_HEALTH_RISKS_DETAILS,
                        state: {
                          comorbidityGroupCode: getComorbiditiesMenuItems()[
                            currentComorbidityGroupCodeIx
                          ].code,
                          comorbidityCode: comorbidityCode,
                          ...getStateToTransfer(),
                        },
                      });
                    }}
                  />
                </div>
              </>
            )}

            {getNotRiskyComorbidities().length > 0 && (
              <>
                <ReportsSectionTitleWithBackground
                  backgroundImage={traitsHeaderBackground}
                  title={`${
                    responseHealthBasedRisks.groups.find(
                      g =>
                        g.code ===
                        getComorbiditiesMenuItems()[
                          currentComorbidityGroupCodeIx
                        ].code
                    ).name
                  } ${t(
                    'reporting.common.comorbiditiesCategories.conditionsNonExisting'
                  )}`}
                />
                <div
                  style={{
                    marginBottom: '60px',
                  }}
                >
                  <ConditionSummaryList
                    conditionSummaries={getNotRiskyComorbidities()}
                    category={
                      responseHealthBasedRisks.groups.find(
                        g =>
                          g.code ===
                          getComorbiditiesMenuItems()[
                            currentComorbidityGroupCodeIx
                          ].code
                      ).name
                    }
                    onClick={comorbidityCode => {
                      trackEvent(
                        'Reporting',
                        `Not risky comorbidity click ${comorbidityCode}`
                      );
                      props.history.push({
                        pathname: ROUTE_ASSESSMENT_HEALTH_RISKS_DETAILS,
                        state: {
                          comorbidityGroupCode: getComorbiditiesMenuItems()[
                            currentComorbidityGroupCodeIx
                          ].code,
                          comorbidityCode: comorbidityCode,
                          ...getStateToTransfer(),
                        },
                      });
                    }}
                  />
                </div>
              </>
            )}
          </>
        )}
      </>
    );
  };

  const StyledTab = withStyles(theme => ({
    root: {
      flexGrow: 1,
      fontSize: 16,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.1,
      letterSpacing: 'normal',
      textAlign: 'left',
      color: '#2a343f',
      lineHeight: 1,
      textTransform: 'none',
      '&$selected': {
        color: '#ffffff',
        backgroundColor: '#2fb9da',
      },
    },
    selected: {},
  }))(props => <Tab disableRipple {...props} />);

  const tabTitles =
    responseHealthBasedRisks == null
      ? []
      : [
          `${
            responseHealthBasedRisks.groups.find(
              g =>
                g.code ===
                getComorbiditiesMenuItems()[currentComorbidityGroupCodeIx].code
            ).name
          } ${t(
            'reporting.common.comorbiditiesCategories.conditionsExisting'
          )}`,
          `${
            responseHealthBasedRisks.groups.find(
              g =>
                g.code ===
                getComorbiditiesMenuItems()[currentComorbidityGroupCodeIx].code
            ).name
          } ${t(
            'reporting.common.comorbiditiesCategories.conditionsNonExisting'
          )}`,
        ];

  const RenderDesktopVersion = () => {
    const condSummary = convertToConditionSummaries(
      currentComorbidityGroupCodeIx
    );
    return (
      <Box>
        {condSummary.length === 1 ? (
          <RiskFactorExplanation risk={condSummary[0]} />
        ) : (
          <>
            <AppBar
              position="static"
              style={{ backgroundColor: '#ffffff', boxShadow: 'none' }}
            >
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="tabs"
                variant="fullWidth"
                TabIndicatorProps={{
                  style: {
                    backgroundColor: BRIGHT_LIGHT_BLUE,
                  },
                }}
              >
                {tabTitles.map((tabTitle, ix) => {
                  return <StyledTab label={tabTitle} id={`tab-${ix}`} />;
                })}
              </Tabs>
            </AppBar>
            <TabPanel value={tabValue} index={0}>
              {() => {
                return getRiskyComorbidites().length > 0 ? (
                  <React.Fragment>
                    <div
                      style={{
                        marginBottom: '60px',
                      }}
                    >
                      <CustomAccordionList
                        conditionSummaries={getRiskyComorbidites()}
                        category={
                          responseHealthBasedRisks.groups.find(
                            g =>
                              g.code ===
                              getComorbiditiesMenuItems()[
                                currentComorbidityGroupCodeIx
                              ].code
                          ).name
                        }
                      />
                    </div>
                  </React.Fragment>
                ) : (
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                  >
                    <Box padding={2} textAlign="center">
                      <Typography>
                        {t(
                          'reporting.common.comorbiditiesCategories.notHavingAny'
                        )}{' '}
                        {
                          responseHealthBasedRisks.groups.find(
                            g =>
                              g.code ===
                              getComorbiditiesMenuItems()[
                                currentComorbidityGroupCodeIx
                              ].code
                          ).name
                        }{' '}
                        {t(
                          'reporting.common.comorbiditiesCategories.conditionsExisting'
                        )}
                      </Typography>
                    </Box>
                  </Grid>
                );
              }}
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              {() => {
                return getNotRiskyComorbidities().length > 0 ? (
                  <React.Fragment>
                    <div
                      style={{
                        marginBottom: '60px',
                      }}
                    >
                      <CustomAccordionList
                        conditionSummaries={getNotRiskyComorbidities()}
                        category={
                          responseHealthBasedRisks.groups.find(
                            g =>
                              g.code ===
                              getComorbiditiesMenuItems()[
                                currentComorbidityGroupCodeIx
                              ].code
                          ).name
                        }
                      />
                    </div>
                  </React.Fragment>
                ) : (
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                  >
                    <Box padding={2} textAlign="center">
                      {' '}
                      <Typography>
                        There is no{' '}
                        {
                          responseHealthBasedRisks.groups.find(
                            g =>
                              g.code ===
                              getComorbiditiesMenuItems()[
                                currentComorbidityGroupCodeIx
                              ].code
                          ).name
                        }{' '}
                        conditons on this list.
                      </Typography>
                    </Box>
                  </Grid>
                );
              }}
            </TabPanel>
          </>
        )}
      </Box>
    );
  };

  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    trackEvent(
      'Reporting',
      `Tab click ${
        newValue === 0 ? 'CONDITIONS YOU HAVE' : 'CONDITIONS YOU DO NOT HAVE'
      }`
    );
    setTabValue(newValue);
  };

  const getStateToTransfer = () => {
    return {
      healthBasedRisks: responseHealthBasedRisks,
      infectionLikelihood: responseLikelihood,
    };
  };

  return (
    <React.Fragment>
      <div style={{ display: 'flex' }}>
        {responseHealthBasedRisks && responseLikelihood && (
          <DesktopMenu
            id={1}
            submenuId={getComorbidityGroupCodeByMenuIndex(
              currentComorbidityGroupCodeIx
            )}
            stateToTransferOnNavigation={getStateToTransfer()}
          />
        )}
        <Grid
          container={isDesktop}
          direction="row"
          justify="center"
          alignItems="center"
          style={{
            width: `calc(100% - ${isDesktop ? 300 : 0}px)`,
          }}
        >
          <PageItemContainer>
            <AppBar
              position="sticky"
              style={{
                backgroundColor: '#ffffff',
                boxShadow: 'none',
              }}
            >
              {isDesktop === false && responseHealthBasedRisks && (
                <Header
                  squeeze
                  title={
                    responseHealthBasedRisks.groups.find(
                      g =>
                        g.code ===
                        getCurrentGroupCode(currentComorbidityGroupCodeIx)
                    ).name
                  }
                  secondaryHeaderWithBackNavigation
                />
              )}
              {!isDesktop && responseHealthBasedRisks && (
                <AppBar
                  position="sticky"
                  style={{
                    backgroundColor: '#ffffff',
                    boxShadow: 'none',
                    borderTop: '1px solid #efefef',
                    borderBottom: '1px solid #efefef',
                  }}
                >
                  <TraitGroupsMenu
                    selIx={currentComorbidityGroupCodeIx}
                    items={getComorbiditiesMenuItems()}
                    groups={responseHealthBasedRisks.groups}
                    onIconClicked={ix => onIconClicked(ix)}
                  />
                </AppBar>
              )}
            </AppBar>
            {responseHealthBasedRisks &&
              (convertToConditionSummaries(currentComorbidityGroupCodeIx)
                .length > 1 && (
                <Box
                  style={{
                    borderBottom: '1px Solid #efefef',
                  }}
                >
                  <RiskGroupAssessmentCard
                    numberOfRisks={getRiskyComorbidites().length}
                    groupName={responseHealthBasedRisks.groups
                      .find(
                        g =>
                          g.code ===
                          getCurrentGroupCode(currentComorbidityGroupCodeIx)
                      )
                      .name.toLowerCase()}
                  />
                </Box>
              ))}

            {responseHealthBasedRisks && (
              <>
                {convertToConditionSummaries(currentComorbidityGroupCodeIx)
                  .length > 1 && (
                  <Box fontSize="25px">
                    <ReportsOpenTextSection
                      paragraphsKeys={[
                        responseHealthBasedRisks.groups.find(
                          g =>
                            g.code ===
                            getCurrentGroupCode(currentComorbidityGroupCodeIx)
                        ).description,
                      ]}
                      sectionFontSize={isDesktop ? 18 : 14}
                    />
                  </Box>
                )}
                {isDesktop ? RenderDesktopVersion() : RenderMobileVersion()}
              </>
            )}
            <ReportsBottomNavigation
              selected={reportsBottomNavigationOptions.healthRisk}
              onSelected={val =>
                props.history.push({
                  pathname: val,
                  state: getStateToTransfer(),
                })
              }
            />
          </PageItemContainer>
        </Grid>
      </div>
    </React.Fragment>
  );
}
